import { navItems } from "~/constants/sidebar";

export const bottomMenuLinks = [
  "nav.mobile_aliexpress_products",
  "nav.import_list",
  "nav.live_products",
  "nav.orders",
];

export const BOTTOM_MENU_LINKS = navItems.flatMap((item) => {
  if (bottomMenuLinks.includes(item.namePath)) {
    return {
      id: item.namePath,
      route: item.path,
      label: item.namePath,
      title: item.namePath,
      icon: item.icon,
      alt: item.path,
      alertPositionTop: 10,
      alertPositionRight: 12,
      hasActiveColorIcon: true,
      getCountQuery: item.getCountQuery,
    };
  }

  return [];
});
